var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetroCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_metro-calendar",
    "data-name": "Icon metro-calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 80,
    viewBox: "0 0 75 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-calendar-2",
    "data-name": "Icon metro-calendar",
    d: "M27.571,31.928h10v10h-10Zm15,0h10v10h-10Zm15,0h10v10h-10Zm-45,30h10v10h-10Zm15,0h10v10h-10Zm15,0h10v10h-10Zm-15-15h10v10h-10Zm15,0h10v10h-10Zm15,0h10v10h-10Zm-45,0h10v10h-10Zm55-45v5h-10v-5h-35v5h-10v-5h-10v80h75v-80h-10Zm5,75h-65v-55h65Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetroCalendar);
export default __webpack_public_path__ + "static/media/Icon_metro-calendar.3d08eebb63d7c0f22ae3ea36fa333218.svg";
export { ForwardRef as ReactComponent };